import api from "./api";

const authService = {
	login: async (email, password) => {
		const response = await api.post("/auth/login", { email, password });
		return response.data;
	},

	logout: () => {
		localStorage.removeItem("token");
	},

	forgotPassword: async (email) => {
		const response = await api.post("/auth/forgot-password", { email });
		return response.data;
	},

	resetPassword: async (token, newPassword) => {
		const response = await api.post("/auth/reset-password", { token, newPassword });
		return response.data;
	},

	// Verify if current token is valid
	verifyToken: async () => {
		try {
			// Try to make an authenticated request
			const response = await api.get("/auth/me");
			return { valid: true, user: response.data };
		} catch (error) {
			return { valid: false, error: error.message };
		}
	},
};

export default authService;
